module.exports = __webpack_public_path__ + "img/dark-logo.c33fc630.svg";